import React from 'react';
import { Button } from './ui/button';
import './PricingCard.css';

const PricingCard = ({ name, price, features, isPopular = false, onGetStarted }) => {
  const handleGetStarted = () => {
    if (onGetStarted) {
      onGetStarted(name);
    }
  };

  return (
    <div className={`pricing-card ${isPopular ? 'popular' : ''}`}>
      {isPopular && <div className="popular-badge">Most Popular</div>}
      <div className="pricing-header">
        <h3 className="pricing-name">{name}</h3>
        <div className="pricing-price">
          <span className="price-symbol">$</span>
          <span className="price-amount">{price}</span>
        </div>
        <p className="pricing-note">+ USPTO Filing Fee</p>
      </div>
      <div className="pricing-features">
        {features.map((feature, index) => (
          <div key={index} className="feature-item">
            <span>{feature}</span>
          </div>
        ))}
      </div>
      <Button 
        onClick={handleGetStarted} 
        className="pricing-button"
        variant={isPopular ? 'default' : 'outline'}
      >
        Get Started
      </Button>
    </div>
  );
};

export default PricingCard;